
import _ from 'underscore';
import Backbone from 'backbone';

import TemplateCache from 'TemplateCache';


const FilterView = Backbone.View.extend({

    events: {
        'click .tag-box': 'toggleTag',
        'click .tags-reset': 'resetSelectedTags',
        'click .tags-submit': 'submitSelectedTags',
    },

    initialize: function() {
        this.listenTo(this.model, "change:error change:loading change:groups", this.render);
    },

    render: function() {
        this.el.innerHTML = TemplateCache.render("interest-filter", this.model.toJSON());
    },

    toggleTag: function(e) {
        e.preventDefault();
        this.model.toggleTag($(e.currentTarget).data('tag'));
    },

    resetSelectedTags: function(e) {
        e.preventDefault();
        this.model.set("selectedTags", []);
    },

    submitSelectedTags: function(e) {
        e.preventDefault();
        this.model.trigger("submit", this.model);
    },
});


const ReservaInterestFilter = Backbone.Model.extend({

    defaults: function() {
        return {
            /* Params */
            groups: [],
            api: "/api/engine/tags/",
            container: null,

            /* State */
            local: location.hostname === "localhost",
            loading: true,
            error: null,
            selectedTags: [],
            totalCount: 0,
            resultsCount: 0,

            tagGroups: [],
        }
    },

    initialize: function() {
        _.bindAll(this, "run", "reset");

        let groups = this.get("groups");
        if ( typeof groups === "string" ) {
            this.set("groups", _(groups.split(',')).map(i => parseInt(i, 10)));
        }

        this.tagMapping = {};
        this.clientTagMapping = {};

        this.on("change:selectedTags", () => {
            this.recountTags(this.get("tagGroups"));
            this.view.render();
        });
    },

    run: function() {
        let groups = this.get("groups").join(",");
        let container = this.get("container");

        if ( !container || !container.length ) {
            throw new Error("ReservaInterestFilter: Invalid container provided: " + container);
        }

        let url = this.get("api") + '?' + $.param({
            groups: groups,
            force_cors: 1,
            clients: 1,
            lang: (window.Tramino && window.Tramino.lang) || "de",
        });

        this.view = new FilterView({
            el: container,
            model: this,
        })
        this.view.render()

        let promise;

        if ( this.get("local") ) {
            let cached = sessionStorage.getItem("interest-filter-cache-2");
            if ( cached ) {
                console.log("[InterestFilter] Using cached tags");
                promise = Promise.resolve(JSON.parse(cached));
            }
        }

        if ( !promise ) {
            console.log("[InterestFilter] Loading tags from server");
            promise = Promise.resolve($.getJSON(url));
        }

        promise.then(
            result => this.onResult(result),
            error => {
                console.log(error);
                this.set({
                    loading: false,
                    error: "Konnte Interessen nicht laden. Bitte versuchen Sie es später nochmal.",
                })
            }
        );
    },

    onResult: function(response) {
        if ( this.get("local") ) {
            sessionStorage.setItem("interest-filter-cache-2", JSON.stringify(response));
        }

        console.log("Result", response);

        /**
         * Tag-Gruppen bauen
         */

        let tagGroups = [];

        var currentGroupName = null;
        var currentTags = [];

        for (var i = 0, result; result = response.tags_info[i]; ++i) {
            // result = { order, group, id, tag, [clients] }
            if ( !currentGroupName ) currentGroupName = result.group;
            if ( currentGroupName != result.group ) {
                tagGroups.push({
                    index: i,
                    name: currentGroupName,
                    tags: currentTags,
                });
                currentGroupName = result.group;
                currentTags = [];
            }

            if ( !result.image ) {
                result.image = "/tramino/gfx/icon_default.jpg";
            }

            if ( result.image.substr(0, 3) === "/s/" ) {
                result.image = "https://tramino.s3.amazonaws.com" + result.image;
            }

            if ( location.hostname === "localhost" && result.image ) {
                if ( result.image.substr(0, 1) === "/" ) {
                    result.image = "http://oberstdorf.tramino.dev" + result.image;
                }
            }

            var clients = result.clients.split(',');

            currentTags.push({
                id: result.id,
                tag: result.tag,
                count: null, /* null = Unknown count */
                image: result.image,
                clients: clients,
            });

            /* Wir erzeugen hier ein Mapping von tag_id => Array von Klassen.
               Dies ermöglicht es uns später, schnell anhand der ausgewählten Tags die Ergebnisse zu filtern */
            for(var j = 0, client_id; client_id = clients[j]; ++j) {
                if ( typeof this.tagMapping[result.id] === "undefined" ) {
                    this.tagMapping[result.id] = [];
                }
                this.tagMapping[result.id].push(parseInt(client_id, 10)); // result.id = tag.id

                if ( typeof this.clientTagMapping[client_id] === "undefined" ) {
                    this.clientTagMapping[client_id] = [];
                }
                this.clientTagMapping[client_id].push(parseInt(result.id, 10)); // result.id = tag.id
            }
        }

        tagGroups.push({
            name: currentGroupName,
            tags: currentTags,
        });

        this.recountTags(tagGroups)

        this.set({
            loading: false,
            totalCount: _.keys(this.clientTagMapping).length,
            tagGroups: tagGroups,
        })
    },

    recountTags: function(tagGroups) {
        let selectedTags = this.get("selectedTags");
        let matching_clients = [];

        if ( selectedTags.length > 0 ) {
            // Für jeden Tag alle Clients ermitteln, die den Tag haben

            let clients_stack = [];

            _.each(selectedTags, tag_id => {
                clients_stack.push(this.tagMapping[tag_id]);
            })

            /*
            clients_stack = [
                [1, 2, 3],
                [2, 3, 4, 5],
                [1, 2, 3, 5]
            ]

            => matching_clients = [2, 3]
            */


            // Nun die gemeinsame Menge finden
            matching_clients = _.intersection.apply(_, clients_stack);
            this.matching_clients = matching_clients;
            console.log("matching_clients", matching_clients);
        }


        // Tags zählen
        let tagCounts = {};
        let resultsCount = 9999;
        _.each(tagGroups, group => { // n = ~3
            _.each(group.tags, tag => { // n = ~10

                if ( selectedTags.length === 0 ) {
                    tagCounts[tag.id] = this.tagMapping[tag.id].length;
                } else {
                    /* For this tag, check which other tags also have the same clients */
                    tagCounts[tag.id] = _.filter(this.tagMapping[tag.id], client => matching_clients.indexOf(client) !== -1).length;
                }

                if ( selectedTags.indexOf(tag.id) !== -1 ) {
                    //console.log(`Math.min(${resultsCount}, ${tagCounts[tag.id]}) = ${Math.min(resultsCount, tagCounts[tag.id])}`);
                    resultsCount = Math.min(resultsCount, tagCounts[tag.id]);
                }

            });
        });

        if ( resultsCount === 9999 ) {
            resultsCount = 0;
        }

        _.each(tagGroups, group => { // n = ~4
            _.each(group.tags, tag => { // n = ~8
                if ( tagCounts[tag.id] ) {
                    tag.count = tagCounts[tag.id];
                } else {
                    tag.count = 0;
                }
            });
            //group.tags = _(group.tags).sortBy(tag => -tag.count);
            group.tags = _(group.tags).sortBy(tag => tag.name);
        }.bind(this));

        this.set({
            resultsCount: resultsCount,
        });
    },


    toggleTag: function(tag_id) {
        var tags = this.get("selectedTags");
        tag_id = parseInt(tag_id, 10);
        if ( _.contains(tags, tag_id) ) {
            tags.splice(tags.indexOf(tag_id), 1);
        } else {
            tags.push(tag_id);
        }

        this.set("selectedTags", tags);
        // Backbone wont trigger on set cause the array is still the same array object
        this.trigger("change:selectedTags", this);
    },

    reset: function() {
        this.set({
            selectedTags: [],
        })
    },

});

export default ReservaInterestFilter;



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/interest-filter.js
 **/